/**
 * 약관·처리방침 공통 값. 이 파일 하나를 고치면 두 문서와 가입 화면에 모두 반영된다.
 * contactEmail은 Cloudflare Email Routing으로 개인 메일함에 전달되도록 만든 주소다
 * (2026-09-22 결정).
 */
export const LEGAL = {
  serviceName: "Dabar Note",
  // 2026-09-30 확정. 로고(펼친 책+십자가)의 흐름을 그대로 말로 옮긴 문구.
  slogan: "말씀이 기록에서 삶으로",
  operatorName: "Dabar Note 운영팀",
  contactEmail: "hello@dabarnote.unhub.kr",
  // 시행일이자 동의 버전. 문서 내용을 바꾸면 같이 올려야 재동의 대상을 가릴 수 있다.
  version: "2026-09-26",
} as const;

// 가입 시 user_metadata.consent에 저장하는 형태
export type ConsentRecord = {
  version: string;
  agreedAt: string;
  terms: true;
  privacy: true;
  sensitive: true;
  overseas: true;
  ageOver14: true;
};
